























import Vue from 'vue';
import { FilterDefaults } from '@/types/constants/TableConstants';

export default Vue.extend({
  name: 'MStoreFilter',
  $_veeValidate: {
    value() {
      return this.value;
    }
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    placeholder: {
      type: String
    },
    value: String,
    dataTestid: {
      type: String,
      default: 'searchbox-input'
    },
    label: {
      type: String
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    debounce: {
      type: Number,
      default: FilterDefaults.Debounce
    }
  },
  computed: {
    inputValue: {
      get(this: any) {
        return this.value;
      },
      set(this: any, value: string) {
        this.$emit('input', value);
      }
    }
  }
});
